<div class="home-wrapper">
  <xui-loading></xui-loading>
</div>
